import { useEffect, useRef, useState } from "react";
import { useLanguage } from "../../../i18n";
import "./Carousel.css";

const images = [
  "/images/html.svg",
  "/images/css.svg",
  "/images/Bootstrap.svg",
  "/images/tailwind-css.svg",
  "/images/javascript.svg",
  "/images/typescript.svg",
  "/images/next.svg",
  "/images/react.svg",
  "/images/angular.svg",
  "/images/microsoft-sql-server.svg",
  "/images/MySQL.svg",
  "/images/mongodb-icon.svg",
  "/images/PHP.svg",
  "/images/symfony.svg",
  "/images/CSharp.svg",
  "/images/dot-net-core.svg",
  "/images/solr.svg",
  "/images/NGINX.svg"
];

const repeatedImages = Array(20).fill(images).flat();

export default function Carousel() {
  const trackRef = useRef(null);
  const positionRef = useRef(0);
  const speedRef = useRef(0.5);
  const animationRef = useRef(null);
  const { t } = useLanguage();

  const handleMouseEnter = () => {
    speedRef.current = 0.2;
  };

  const handleMouseLeave = () => {
    speedRef.current = 0.5;
  };

  useEffect(() => {
    const track = trackRef.current;

    const scroll = () => {
      positionRef.current -= speedRef.current;
      track.style.transform = `translateX(${positionRef.current}px)`;

      if (Math.abs(positionRef.current) >= track.scrollWidth / 2) {
        positionRef.current = 0;
        track.style.transform = `translateX(0)`;
      }

      animationRef.current = requestAnimationFrame(scroll);
    };

    animationRef.current = requestAnimationFrame(scroll);

    return () => cancelAnimationFrame(animationRef.current);
  }, []);

  return (
    <div>
      <h2>{t("carousel.title")}</h2>
      <div
        className="carousel-wrapper"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="carousel-track" ref={trackRef}>
          {repeatedImages.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`${t("carousel.logoAlt")} ${index + 1}`}
              className="carousel-icon"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
